/* eslint-disable max-len */
import React, { FC } from "react";

type IProps = {
    width?: number;
    height?: number;
};

const ExpandPlusIcon: FC<IProps> = ({ width = 16, height = 17 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 16 17"
    fill="none">
    <path d="M3.33398 8.03874H12.6673M8.00065 3.37207V12.7054" stroke="#262626" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5"/>
  </svg>
);

export default ExpandPlusIcon;
